import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface EntryOptionProps {
  /** The glyph: each caller passes its own (BowerIcon or MaterialIcon). */
  readonly icon: ReactNode;
  readonly title: string;
  readonly description: string;
  readonly onClick: () => void;
  readonly isDisabled?: boolean;
  readonly isLoading?: boolean;
}

/**
 * One way in to a create flow ("Attach a file", "Start from scratch", "Scan a
 * photo"…). The protocol, spreadsheet and equipment steps all use it, so the
 * three read as one pattern; it was three copies of the same markup.
 */
export function EntryOption({
  icon,
  title,
  description,
  onClick,
  isDisabled,
  isLoading,
}: EntryOptionProps) {
  return (
    <Button
      variant="outline-option"
      onClick={onClick}
      isDisabled={isDisabled}
      isLoading={isLoading}
    >
      <HStack spacing={3} align="flex-start" w="full">
        {icon}
        <VStack spacing={0.5} align="flex-start" flex={1}>
          <Text fontSize="sm" fontWeight="medium" color="text.primary">
            {title}
          </Text>
          <Text fontSize="xs" color="text.secondary" whiteSpace="normal" textAlign="left">
            {description}
          </Text>
        </VStack>
      </HStack>
    </Button>
  );
}
